import type { QueryClient } from '@tanstack/react-query'
import type { PersistedWidgetSpec } from 'shared/types/widgets'

type WidgetWriteQueue = {
  tail: Promise<void>
  revision: number
  latestWidgets: PersistedWidgetSpec[]
  needsReconcile: boolean
}

const queues = new WeakMap<QueryClient, WidgetWriteQueue>()

export const getWidgetWriteQueue = (
  queryClient: QueryClient
): WidgetWriteQueue => {
  let queue = queues.get(queryClient)
  if (!queue) {
    queue = {
      tail: Promise.resolve(),
      revision: 0,
      latestWidgets: [],
      needsReconcile: false
    }
    queues.set(queryClient, queue)
  }
  return queue
}

export const enqueueWidgetWrite = <T>(
  queryClient: QueryClient,
  write: () => Promise<T>
): Promise<T> => {
  const queue = getWidgetWriteQueue(queryClient)
  const task = queue.tail.then(write)
  queue.tail = task.then(
    () => {},
    () => {}
  )
  return task
}
